<template lang="pug">
  div
    p.title(v-if="title.length") {{ title }}
    ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator")
      v-form(@submit.prevent="handleSubmit(addField)")
        v-simple-table
          template(v-slot:default)
            thead(v-if="headers.length")
              tr
                th(v-for="(head,i) in headers", :key="'head'+i") {{ head }}
                th
            tbody
              tr(v-for="(field,j) in createdFields", :key="'field'+j")
                td.py-2 {{ j+1 }}
                td.py-2 {{ field.name }}
                td.py-2 {{ field.points }}
                td.py-2
                  v-icon(v-if="field.rollDown" color="green lighten-1") mdi-check
                  v-icon(v-else color="red lighten-1") mdi-close
                td.py-2 {{ field.percentage }}
                td.py-2
                  v-btn(@click="removeField(j)" color="red lighten-2" small dark) {{ translations.button.remove }}
              tr
                td.py-2
                td.py-2
                  BaseTextField(v-model="emptyfield.name" label="Nombre")
                td.py-2
                  BaseTextField(rules="numeric" v-model="emptyfield.points" label="Puntos")
                td.py-2
                  v-switch(v-model="emptyfield.rollDown")
                td.py-2
                  BaseTextField(rules="numeric" v-model="emptyfield.percentage" label="Percentaje")
                td.py-2
                  v-btn(type="submit" color="green lighten-2" small dark :disabled="emptyfield.name == '' || emptyfield.points == '' || emptyfield.percentage == ''") {{ translations.button.add }}
              tr
                td.py-2(colspan="3")
                  p(v-if="percentageTotal != 100")
                    v-icon.pr-1(color="red accent-2" size="12") mdi-asterisk
                    span.red--text {{ translations.dialog.advise.percentage }}
                td.py-2 Total percentaje
                td.py-2.text-right {{ percentageTotal }}
                td.py-2
    v-dialog.grey(v-model="dialog" max-width="400")
      v-card
        v-card-title.d-flex.flex-nowrap.justify-space-between.headline.text-center(primary-title)
          span {{ translations.dialog.title }}
          v-btn(@click="dialog = false" icon)
            v-icon mdi-close
        v-card-text
          v-row.text-center
            v-col(cols="12")
              p {{ dialogtext }}
            v-col(cols="12")
              v-btn(@click="dialog = false") {{ translations.dialog.button }}
</template>

<script>
  export default {
    name: "BaseDynamicLevel",
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      value: {
        type: Array,
        default: function(){
          return []
        }
      },
      title: {
        type: String,
        default: ''
      },
      headers: {
        type: Array,
        default: function(){
          return []
        }
      }
    },
    data:() => ({
      emptyfield: {
        name: '',
        points: '',
        rollDown: false,
        percentage: '',
      },
      createdFields: [],
      dialog: false,
      dialogtext: '',
      lastPoints: null,
      lastPercentage: 0,
    }),
    computed: {
      translations(){
        return this.$t("components.baseDynamicLevel");
      },
      percentageTotal(){
        if(this.createdFields.length){
          return this.createdFields.reduce((acc,cur)=>{
            return acc + cur.percentage;
          }, 0);
        } else {
          return 0;
        }
      },
    },
    watch: {
      value: function(val){
        this.createdFields = val;
      }
    },
    created(){
      this.createdFields = this.value;
    },
    methods:{
      addField(){
        if (this.lastPoints != null && parseInt(this.emptyfield.points) >= this.lastPoints){
          this.dialog = true;
          this.dialogtext = this.translations.dialog.advise.points;
        } else {
          this.createdFields.push({
            name: this.emptyfield.name,
            points: parseInt(this.emptyfield.points),
            rollDown: this.emptyfield.rollDown,
            percentage: parseInt(this.emptyfield.percentage),
          });
          this.lastPoints = parseInt(this.emptyfield.points);
          this.lastPercentage = this.emptyfield.percentage;
          this.clear();
          this.$emit('input', this.createdFields);
        }
      },
      removeField(key){
        if(this.createdFields.length > 1){
          this.lastPoints = this.createdFields[this.createdFields.length - 2].points;
        } else {
          this.lastPoints = null;
        }
        this.createdFields.splice(key, 1);
        this.$emit('input', this.createdFields);
      },
      clear(){
        this.emptyfield.name = '';
        this.emptyfield.points = '';
        this.emptyfield.rollDown = false;
        this.emptyfield.percentage = '';
        this.$refs.validator.reset();
      },
    },
  }
</script>

<style lang="sass">
</style>